import { onMounted, onBeforeUnmount } from 'vue';
import { useLoader } from '@flash-global66/g-loader';

/**
 * Apaga el loader global cuando el navegador restaura la página desde su caché de navegación.
 * Una restauración devuelve el estado en memoria tal como quedó al salir hacia una pasarela
 * externa, incluido el loader que se encendió justo antes de redirigir.
 * @returns No retorna valor; solo registra y limpia el listener de restauración.
 */
export function useStaleLoaderGuard(): void {
  const { showGLoader } = useLoader();

  function hideRestoredLoader(event: PageTransitionEvent): void {
    if (!event.persisted) return;
    showGLoader(false);
  }

  onMounted(() => {
    window.addEventListener('pageshow', hideRestoredLoader);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('pageshow', hideRestoredLoader);
  });
}
